var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center fill-height"},[_c('div',{staticClass:"text-center text-h1 font-weight-bold"},[_vm._v("404")]),_c('wave',{staticClass:"text-center"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }